export default {
    zh: {
        characterToImage: '角色图片',
        origin_img: '原始图片',
        sexy: '性别',
        interest: '兴趣',
        clickAddCharacter: '点击添加形象',
        continueAdd: '继续添加',
        pleaseImageCheck: '请选择角色或者上传图片',
        cancel: '取消',
        confirm: '确定',
        chooseCharacter: '选择角色',
        maxUploadCount: '构图数量最多为 {count} 张',
        chat_character: '聊过的角色',
        all_character: '所有角色',
        chooseCharacterDesc: '从角色库添加',
        uploadImage: '上传图片',
        uploadImageDesc: '支持jpg,png,webp格式',
        multiCharacter: '多角色生图',
        // 角色生视频
        characterToVideo: '角色视频',
        // 未翻译
        singleCharacterReference: '单角色参考',
        framesMultiCharacter: '多角色首尾帧',
        multiCharacterToImg: '多角色参考',
        me: '我',
        character: '形象',
        imageFormatSupport: '当前创作模式不支持该文件类型',
        imageSizeLimit: '图片大小不能超过 {maxSize}MB：',
        imageResolutionLimit: '图片分辨率过大，最长边不能超过 {maxResolution}px：',
        andOthers: ' 等{count}个文件',
    },
    en: {
        characterToImage: 'Char2Img',
        origin_img: 'Original Image',
        sexy: 'Sexy',
        interest: 'Interest',
        clickAddCharacter: 'Click to add character',
        continueAdd: 'Continue Adding',
        pleaseImageCheck: 'Please select a character or upload an image',
        cancel: 'Cancel',
        confirm: 'Confirm',
        chooseCharacter: 'Choose Character',
        maxUploadCount: 'The maximum number of compositions is {count}',
        chat_character: 'Chatted characters',
        all_character: 'All characters',
        chooseCharacterDesc: 'Add from character library',
        uploadImage: 'Upload image',
        uploadImageDesc: 'Supports jpg,png,webp format',
        multiCharacter: 'Multi-character generation',

        // 角色生视频
        characterToVideo: 'Char2Vid',
        me: 'Me',
        character: 'Character',
        imageFormatSupport: 'The current creation mode does not support this file type',
        imageSizeLimit: 'Image size cannot exceed {maxSize}MB: ',
        imageResolutionLimit: 'Image resolution is too large, the longest side cannot exceed {maxResolution}px: ',
        andOthers: ' and {count} other files',
    },
    ja: {
        characterToImage: 'キャラ画像',
        origin_img: '元の画像',
        sexy: '性別',
        interest: '興味',
        clickAddCharacter: 'キャラクターを追加する',
        continueAdd: '続けて追加',
        pleaseImageCheck: 'キャラクターまたは画像を選択してください',
        cancel: 'キャンセル',
        confirm: '確定',
        chooseCharacter: 'キャラクターを選択',
        maxUploadCount: '構図数は最大 {count} 枚までです',
        chat_character: 'チャットしたキャラクター',
        all_character: 'すべてのキャラクター',
        chooseCharacterDesc: 'キャラクターライブラリから追加',
        uploadImage: '画像をアップロード',
        uploadImageDesc: 'jpg,png,webp形式をサポート',
        multiCharacter: '複数キャラクター生成',

        // 角色生视频
        characterToVideo: 'キャラ動画',
        me: '私',
        character: 'キャラクター',
        imageFormatSupport: '現在の作成モードではこのファイル形式はサポートされていません',
        imageSizeLimit: '画像サイズは {maxSize}MB を超えることはできません：',
        imageResolutionLimit: '画像の解像度が大きすぎます。最長辺は {maxResolution}px を超えることはできません：',
        andOthers: ' 他 {count} 個のファイル',
    },
    ko: {
        characterToImage: '캐릭터 이미지',
        origin_img: '원본 이미지',
        sexy: '성별',
        interest: '관심사',
        clickAddCharacter: '캐릭터를 추가하세요',
        continueAdd: '계속 추가',
        pleaseImageCheck: '캐릭터 또는 이미지를 선택하세요',
        cancel: '취소',
        confirm: '확인',
        chooseCharacter: '캐릭터 선택',
        maxUploadCount: '구성 수는 최대 {count} 장까지 입니다',
        chat_character: '채팅한 캐릭터',
        all_character: '모든 캐릭터',
        chooseCharacterDesc: '캐릭터 라이브러리에서 추가',
        uploadImage: '이미지 업로드',
        uploadImageDesc: 'jpg,png,webp 형식 지원',
        multiCharacter: '다중 캐릭터 생성',
        // 角色生视频
        characterToVideo: '캐릭터 영상',
        me: '나',
        character: '캐릭터',
        imageFormatSupport: '현재 생성 모드에서는 이 파일 형식을 지원하지 않습니다',
        imageSizeLimit: '이미지 크기는 {maxSize}MB를 초과할 수 없습니다: ',
        imageResolutionLimit: '이미지 해상도가 너무 큽니다. 가장 긴 면은 {maxResolution}px를 초과할 수 없습니다: ',
        andOthers: ' 외 {count}개 파일',
    },
    tw: {
        characterToImage: '角色圖片',
        origin_img: '原始圖片',
        sexy: '性感',
        interest: '興趣',
        clickAddCharacter: '點擊添加角色',
        continueAdd: '繼續添加',
        pleaseImageCheck: '請選擇角色或者上傳圖片',
        cancel: '取消',
        confirm: '確定',
        chooseCharacter: '選擇角色',
        maxUploadCount: '構圖數最多為 {count} 張',
        chat_character: '聊過的角色',
        all_character: '所有角色',
        chooseCharacterDesc: '從角色庫添加',
        uploadImage: '上傳圖片',
        uploadImageDesc: '支持jpg,png,webp格式',
        multiCharacter: '多角色生圖',
        // 角色生视频
        characterToVideo: '角色影片',
        me: '我',
        character: '形象',
        imageFormatSupport: '目前黃作模式不支援此檔案類型',
        imageSizeLimit: '圖片大小不能超過 {maxSize}MB：',
        imageResolutionLimit: '圖片解析度過大，最長邊不能超過 {maxResolution}px：',
        andOthers: ' 等{count}個文件',
    },
    pl: {
        characterToImage: 'Postać Obraz',
        origin_img: 'Obrazy oryginalne',
        sexy: 'Sexy',
        interest: 'Zainteresowanie',
        clickAddCharacter: 'Kliknij, aby dodać postać',
        continueAdd: 'Kontynuuj dodawanie',
        pleaseImageCheck: 'Wybierz postać lub załaduj obraz',
        cancel: 'Anuluj',
        confirm: 'Potwierdź',
        chooseCharacter: 'Wybierz postać',
        maxUploadCount: 'Maksymalna liczba kompozycji to {count}',
        chat_character: 'Postacie rozmówione',
        all_character: 'Wszystkie postacie',
        chooseCharacterDesc: 'Dodaj z biblioteki postaci',
        uploadImage: 'Załaduj obraz',
        uploadImageDesc: 'Obsługuje jpg,png,webp format',
        multiCharacter: 'Generowanie wielu postaci',
        // 角色生视频
        characterToVideo: 'Postać Wideo',
        me: 'Ja',
        character: 'Postać',
        imageFormatSupport: 'Bieżący tryb tworzenia nie obsługuje tego typu pliku',
        imageSizeLimit: 'Rozmiar obrazu nie może przekraczać {maxSize}MB: ',
        imageResolutionLimit: 'Rozdzielczość obrazu jest zbyt duża, najdłuższy bok nie może przekraczać {maxResolution}px: ',
        andOthers: ' i {count} innych plików',
    },
    es: {
        characterToImage: 'Personaje Imagen',
        origin_img: 'Imagen original',
        sexy: 'Sexy',
        interest: 'Interés',
        clickAddCharacter: 'Haga clic para agregar personaje',
        continueAdd: 'Continuar agregando',
        pleaseImageCheck: 'Seleccione un personaje o cargue una imagen',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        chooseCharacter: 'Seleccionar personaje',
        maxUploadCount: 'El número máximo de composiciones es {count}',
        chat_character: 'Personajes chatteados',
        all_character: 'Todos los personajes',
        chooseCharacterDesc: 'Añadir desde la biblioteca de personajes',
        uploadImage: 'Cargar imagen',
        uploadImageDesc: 'Soporta jpg,png,webp format',
        multiCharacter: 'Generación de personajes múltiples',
        // 角色生视频
        characterToVideo: 'Personaje Video',
        me: 'Yo',
        character: 'Personaje',
        imageFormatSupport: 'El modo de creación actual no admite este tipo de archivo',
        imageSizeLimit: 'El tamaño de la imagen no puede exceder los {maxSize}MB: ',
        imageResolutionLimit: 'La resolución de la imagen es demasiado grande, el lado más largo no puede exceder los {maxResolution}px: ',
        andOthers: ' y otros {count} archivos',
    },
    fr: {
        characterToImage: 'Perso Image',
        origin_img: 'Image originale',
        sexy: 'Sexy',
        interest: 'Intérêt',
        clickAddCharacter: 'Cliquez pour ajouter personnage',
        continueAdd: 'Continuer à ajouter',
        pleaseImageCheck: 'Sélectionnez un personnage ou chargez une image',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        chooseCharacter: 'Ajouter personnage',
        maxUploadCount: 'Le nombre maximum de compositions est {count}',
        chat_character: 'Personnages chattés',
        all_character: 'Tous les personnages',
        chooseCharacterDesc: 'Ajouter depuis la bibliothèque de personnages',
        uploadImage: 'Télécharger image',
        uploadImageDesc: 'Suppporte jpg,png,webp format',
        multiCharacter: 'Génération de personnages multiples',
        // 角色生视频
        characterToVideo: 'Perso Vidéo',
        me: 'Moi',
        character: 'Personnage',
        imageFormatSupport: 'Le mode de création actuel ne prend pas en charge ce type de fichier',
        imageSizeLimit: 'La taille de l\'image ne peut pas dépasser {maxSize}Mo : ',
        imageResolutionLimit: 'La résolution de l\'image est trop grande, le côté le plus long ne peut pas dépasser {maxResolution}px : ',
        andOthers: ' et {count} autres fichiers',
    },
    de: {
        characterToImage: 'Charakter Bild',
        origin_img: 'Originalbild',
        sexy: 'Sexy',
        interest: 'Interesse',
        clickAddCharacter: 'Klicken Sie, um Charakter hinzuzufügen',
        continueAdd: 'Weiterhin hinzufügen',
        pleaseImageCheck: 'Wählen Sie einen Charakter oder laden Sie ein Bild',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        chooseCharacter: 'Charakter auswählen',
        maxUploadCount: 'Die maximale Anzahl von Kompositionen ist {count}',
        chat_character: 'Gesprächspartner',
        all_character: 'Alle Charaktere',
        chooseCharacterDesc: 'Charakterbibliothek hinzufügen',
        uploadImage: 'Bild hochladen',
        uploadImageDesc: 'Unterstützt jpg,png,webp Format',
        multiCharacter: 'Multi-Charakter-Generierung',
        // 角色生视频
        characterToVideo: 'Charakter Video',
        me: 'Ich',
        character: 'Charakter',
        imageFormatSupport: 'Der aktuelle Erstellungsmodus unterstützt diesen Dateityp nicht',
        imageSizeLimit: 'Die Bildgröße darf {maxSize}MB nicht überschreiten: ',
        imageResolutionLimit: 'Die Bildauflösung ist zu groß, die längste Seite darf {maxResolution}px nicht überschreiten: ',
        andOthers: ' und {count} weitere Dateien',
    },
    it: {
        characterToImage: 'Pers Immagine',
        origin_img: 'Immagine originale',
        sexy: 'Sexy',
        interest: 'Interesse',
        clickAddCharacter: 'Clicca per aggiungere personaggio',
        continueAdd: 'Continuare a aggiungere',
        pleaseImageCheck: 'Seleziona un personaggio o carica un immagine',
        cancel: 'Annulla',
        confirm: 'Conferma',
        chooseCharacter: 'Seleziona personaggio',
        maxUploadCount: 'Il numero massimo di composizioni è {count}',
        chat_character: 'Personaggi chattati',
        all_character: 'Tutti i personaggi',
        chooseCharacterDesc: 'Aggiungere dalla libreria dei personaggi',
        uploadImage: 'Caricare immagine',
        uploadImageDesc: 'Supporta jpg,png,webp format',
        multiCharacter: 'Generazione di personaggi multipli',
        // 角色生视频
        characterToVideo: 'Pers Video',
        me: 'Io',
        character: 'Personaggio',
        imageFormatSupport: 'La modalità di creazione corrente non supporta questo tipo di file',
        imageSizeLimit: 'La dimensione dell\'immagine non può superare {maxSize}MB: ',
        imageResolutionLimit: 'La risoluzione dell\'immagine è troppo grande, il lato più lungo non può superare {maxResolution}px: ',
        andOthers: ' e altri {count} file',
    },
    pt: {
        characterToImage: 'Pers Imagem',
        origin_img: 'Imagem original',
        sexy: 'Sexy',
        interest: 'Interesse',
        clickAddCharacter: 'Clique para adicionar personagem',
        continueAdd: 'Continuar adicionando',
        pleaseImageCheck: 'Selecione um personagem ou carregue uma imagem',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        chooseCharacter: 'Selecionar personagem',
        maxUploadCount: 'O número máximo de composições é {count}',
        chat_character: 'Personagens chatados',
        all_character: 'Todos os personagens',
        chooseCharacterDesc: 'Adicionar da biblioteca de personagens',
        uploadImage: 'Carregar imagem',
        uploadImageDesc: 'Suporta jpg,png,webp format',
        multiCharacter: 'Geração de personagens múltiplos',
        // 角色生视频
        characterToVideo: 'Pers Vídeo',
        me: 'Eu',
        character: 'Personagem',
        imageFormatSupport: 'O modo de criação atual não é compatível com este tipo de arquivo',
        imageSizeLimit: 'O tamanho da imagem não pode exceder {maxSize}MB: ',
        imageResolutionLimit: 'A resolução da imagem é muito grande, o lado mais longo não pode exceder {maxResolution}px: ',
        andOthers: ' e outros {count} arquivos',
    },
    ru: {
        characterToImage: 'Перс Изо',
        origin_img: 'Оригинальное изображение',
        sexy: 'Sexy',
        interest: 'Интерес',
        clickAddCharacter: 'Нажмите, чтобы добавить персонажа',
        continueAdd: 'Продолжить добавление',
        pleaseImageCheck: 'Выберите персонажа или загрузите изображение',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        chooseCharacter: 'Выбрать персонажа',
        maxUploadCount: 'Максимальное количество композиций - {count}',
        chat_character: 'Общаться с персонажами',
        all_character: 'Все персонажи',
        chooseCharacterDesc: 'Добавить из библиотеки персонажей',
        uploadImage: 'Загрузить изображение',
        uploadImageDesc: 'Поддерживает jpg,png,webp формат',
        multiCharacter: 'Генерация персонажей',
        // 角色生视频
        characterToVideo: 'Перс Видео',
        me: 'Я',
        character: 'Персонаж',
        imageFormatSupport: 'Текущий режим создания не поддерживает этот тип файла',
        imageSizeLimit: 'Размер изображения не может превышать {maxSize}МБ: ',
        imageResolutionLimit: 'Разрешение изображения слишком велико, самая длинная сторона не может превышать {maxResolution}пикс: ',
        andOthers: ' и еще {count} файлов',
    },
    ar: {
        characterToImage: 'شخصية صورة',
        origin_img: 'الصورة الأصلية',
        sexy: 'Sexy',
        interest: 'الاهتمام',
        clickAddCharacter: 'اضغط لإضافة الشخصية',
        continueAdd: 'استمر في الإضافة',
        pleaseImageCheck: 'اختر شخصية أو قم بتحميل صورة',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        chooseCharacter: 'اختر الشخصية',
        maxUploadCount: 'الحد الأقصى لعدد التركيبات هو {count}',
        chat_character: 'الشخصيات المتحدثة',
        all_character: 'جميع الشخصيات',
        chooseCharacterDesc: 'إضافة من مكتبة الشخصيات',
        uploadImage: 'تحميل الصورة',
        uploadImageDesc: 'يدعم jpg,png,webp format',
        multiCharacter: 'إنشاء صور من مجموعة من الشخصيات',
        // 角色生视频
        characterToVideo: 'شخصية فيديو',
        me: 'أنا',
        character: 'شخصية',
        imageFormatSupport: 'وضع الإنشاء الحالي لا يدعم هذا النوع من الملفات',
        imageSizeLimit: 'لا يمكن أن يتجاوز حجم الصورة {maxSize} ميجابايت: ',
        imageResolutionLimit: 'دقة الصورة كبيرة جدًا، ولا يمكن أن يتجاوز الجانب الأطول {maxResolution} بكسل: ',
        andOthers: ' و {count} ملفات أخرى',
    },
    th: {
        characterToImage: 'ตัวละครภาพ',
        origin_img: 'รูปภาพต้นฉบับ',
        sexy: 'Sexy',
        interest: 'ความสนใจ',
        clickAddCharacter: 'คลิกเพื่อเพิ่มตัวละคร',
        continueAdd: 'ต่อไป',
        pleaseImageCheck: 'เลือกตัวละครหรืออัปโหลดรูปภาพ',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        chooseCharacter: 'เลือกตัวละคร',
        maxUploadCount: 'จำนวนรูปภาพสูงสุดคือ {count}',
        chat_character: 'ตัวละครที่คุย',
        all_character: 'ตัวละครทั้งหมด',
        chooseCharacterDesc: 'เพิ่มจากฐานข้อมูลตัวละคร',
        uploadImage: 'อัปโหลดรูปภาพ',
        uploadImageDesc: 'รองรับรูปภาพรูปแบบ jpg,png,webp',
        multiCharacter: 'สร้างรูปภาพจากตัวละครหลายตัว',
        // 角色生视频
        characterToVideo: 'ตัวละครวิดีโอ',
        me: 'ฉัน',
        character: 'ตัวละคร',
        imageFormatSupport: 'โหมดการสร้างปัจจุบันไม่รองรับประเภทไฟล์นี้',
        imageSizeLimit: 'ขนาดรูปภาพต้องไม่เกิน {maxSize}MB: ',
        imageResolutionLimit: 'ความละเอียดของรูปภาพใหญ่เกินไป ด้านที่ยาวที่สุดต้องไม่เกิน {maxResolution}px: ',
        andOthers: ' และไฟล์อื่นๆ อีก {count} ไฟล์',
    },
    da: {
        characterToImage: 'Karakter Billede',
        origin_img: 'Original billede',
        sexy: 'Sexy',
        interest: 'Interesse',
        clickAddCharacter: 'Klik for at tilføje karakter',
        continueAdd: 'Fortsæt tilføjelse',
        pleaseImageCheck: 'Vælg karakter eller upload billede',
        cancel: 'Annuller',
        confirm: 'Bekræft',
        chooseCharacter: 'Vælg karakter',
        maxUploadCount: 'Maksimal antal kompositioner er {count}',
        chat_character: 'Chattede karakterer',
        all_character: 'Alle karaktere',
        chooseCharacterDesc: 'Tilføj fra karakterbibliotek',
        uploadImage: 'Upload billede',
        uploadImageDesc: 'Understøtter jpg,png,webp format',
        multiCharacter: 'Multi-karakter-generering',
        // 角色生视频
        characterToVideo: 'Karakter Video',
        me: 'Mig',
        character: 'Karakter',
        imageFormatSupport: 'Den aktuelle oprettelsestilstand understøtter ikke denne filtype',
        imageSizeLimit: 'Billedstørrelsen må ikke overstige {maxSize}MB: ',
        imageResolutionLimit: 'Billedopløsningen er for stor, den længste side må ikke overstige {maxResolution}px: ',
        andOthers: ' og {count} andre filer',
    },
    no: {
        characterToImage: 'Karakter Bilde',
        origin_img: 'Original bilde',
        sexy: 'Sexy',
        interest: 'Interesse',
        clickAddCharacter: 'Klikk for å legge til karakter',
        continueAdd: 'Fortsett å legge til',
        pleaseImageCheck: 'Velg karakter eller last opp bilde',
        cancel: 'Avbryt',
        confirm: 'Bekreft',
        chooseCharacter: 'Velg karakter',
        maxUploadCount: 'Maksimal antall komposisjoner er {count}',
        chat_character: 'Chattede karaktere',
        all_character: 'Alle karaktere',
        chooseCharacterDesc: 'Legg til fra karakterbibliotek',
        uploadImage: 'Last opp bilde',
        uploadImageDesc: 'Støtter jpg,png,webp format',
        multiCharacter: 'Multi-karakter-generering',
        // 角色生视频
        characterToVideo: 'Karakter Video',
        me: 'Meg',
        character: 'Karakter',
        imageFormatSupport: 'Gjeldende opprettelsesmodus støtter ikke denne filtypen',
        imageSizeLimit: 'Bildestørrelsen kan ikke overstige {maxSize}MB: ',
        imageResolutionLimit: 'Bildeoppløsningen er for stor, den lengste siden kan ikke overstige {maxResolution}px: ',
        andOthers: ' og {count} andre filer',
    },
    nl: {
        characterToImage: 'Pers Beeld',
        origin_img: 'Originele afbeelding',
        sexy: 'Sexy',
        interest: 'Interesse',
        clickAddCharacter: 'Klik voor het toevoegen van karakter',
        continueAdd: 'Doorgaan met toevoegen',
        pleaseImageCheck: 'Selecteer karakter of upload afbeelding',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        chooseCharacter: 'Selecteer karakter',
        maxUploadCount: 'Het maximaal aantal composities is {count}',
        chat_character: 'Gepraat karakters',
        all_character: 'Alle karakters',
        chooseCharacterDesc: 'Toevoegen van karakterbibliotheek',
        uploadImage: 'Upload afbeelding',
        uploadImageDesc: 'Ondersteunt jpg,png,webp format',
        multiCharacter: 'Multi-karakter-generatie',
        // 角色生视频
        characterToVideo: 'Pers Video',
        me: 'Ik',
        character: 'Karakter',
        imageFormatSupport: 'De huidige aanmaakmodus ondersteunt dit bestandstype niet',
        imageSizeLimit: 'Afbeeldingsgrootte mag niet groter zijn dan {maxSize}MB: ',
        imageResolutionLimit: 'Afbeeldingsresolutie is te groot, de langste zijde mag niet groter zijn dan {maxResolution}px: ',
        andOthers: ' en {count} andere bestanden',
    },
    id: {
        characterToImage: 'Karakter Gambar',
        origin_img: 'Gambar asli',
        sexy: 'Sexy',
        interest: 'Interest',
        clickAddCharacter: 'Klik untuk menambahkan karakter',
        continueAdd: 'Lanjutkan menambahkan',
        pleaseImageCheck: 'Pilih karakter atau unggah gambar',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
        chooseCharacter: 'Pilih karakter',
        maxUploadCount: 'Jumlah komposisi maksimal adalah {count}',
        chat_character: 'Karakter yang berbicara',
        all_character: 'Semua karakter',
        chooseCharacterDesc: 'Tambahkan dari library karakter',
        uploadImage: 'Unggah gambar',
        uploadImageDesc: 'Mendukung format jpg,png,webp',
        multiCharacter: 'Pembuatan karakter multi',
        // 角色生视频
        characterToVideo: 'Karakter Video',
        me: 'Saya',
        character: 'Karakter',
        imageFormatSupport: 'Mode pembuatan saat ini tidak mendukung jenis file ini',
        imageSizeLimit: 'Ukuran gambar tidak boleh melebihi {maxSize}MB: ',
        imageResolutionLimit: 'Resolusi gambar terlalu besar, sisi terpanjang tidak boleh melebihi {maxResolution}px: ',
        andOthers: ' dan {count} file lainnya',
    },
    tr: {
        characterToImage: 'Karakter Görsel',
        origin_img: 'Orjinal resim',
        sexy: 'Sexy',
        interest: 'İlgi',
        clickAddCharacter: 'Karakter eklemek için tıklayın',
        continueAdd: 'Devam et',
        pleaseImageCheck: 'Karakter seçin veya resim yükleyin',
        cancel: 'İptal',
        confirm: 'Onayla',
        chooseCharacter: 'Karakter seçin',
        maxUploadCount: 'En fazla {count} kompozisyon',
        chat_character: 'Konuşan karakterler',
        all_character: 'Tüm karakterler',
        chooseCharacterDesc: 'Karakter kitaplığına ekle',
        uploadImage: 'Resim yükle',
        uploadImageDesc: 'jpg,png,webp formatı destekler',
        multiCharacter: 'Karakter çoklu oluşturma',
        // 角色生视频
        characterToVideo: 'Karakter Video',
        me: 'Ben',
        character: 'Karakter',
        imageFormatSupport: 'Mevcut oluşturma modu bu dosya türünü desteklemiyor',
        imageSizeLimit: 'Resim boyutu {maxSize}MB\'ı aşamaz: ',
        imageResolutionLimit: 'Resim çözünürlüğü çok büyük, en uzun kenar {maxResolution}px\'i aşamaz: ',
        andOthers: ' ve diğer {count} dosya',
    },
}
